import '@inbox-demo-nx/theme';

import { useDripsyTheme, useResponsiveValue } from 'dripsy';
import { ReactNode, useEffect } from 'react';
import { Pressable, StyleProp, ViewStyle } from 'react-native';
import Animated, {
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

export default function ListItem({
  children,
  onPress,
  viewStyle,
}: {
  children: ReactNode;
  onPress?: () => void;
  viewStyle?: StyleProp<ViewStyle>;
}) {
  const { theme } = useDripsyTheme();
  const backgroundOpacity = useSharedValue(0);
  const scale = useSharedValue(1);
  const borderRadius = useSharedValue(0);
  const animatedStyles = useAnimatedStyle(() => ({
    backgroundColor: interpolateColor(
      backgroundOpacity.value,
      [0, 1],
      [theme.colors.listItemBackground, theme.colors.listItemBackgroundHover]
    ),
    transform: [{ scale: scale.value }],
    borderRadius: borderRadius.value,
  }));

  const defaultBorderRadius = useResponsiveValue([0, 8]);

  useEffect(() => {
    borderRadius.value = defaultBorderRadius;
  }, [borderRadius, defaultBorderRadius]);

  return (
    <Pressable
      // @ts-ignore
      onHoverIn={() => {
        backgroundOpacity.value = withTiming(1);
      }}
      onHoverOut={() => {
        backgroundOpacity.value = withTiming(0);
      }}
      onPressIn={() => {
        backgroundOpacity.value = withTiming(1);
        scale.value = withTiming(0.95);
        borderRadius.value = withTiming(12);
      }}
      onPressOut={() => {
        backgroundOpacity.value = withTiming(0);
        scale.value = withTiming(1);
        borderRadius.value = 0;
      }}
      onPress={onPress}
    >
      <Animated.View style={[animatedStyles, viewStyle]}>
        {children}
      </Animated.View>
    </Pressable>
  );
}
